<ion-content>
  <ion-row class="title-head">
    <ion-col size="10">
      <p class="status-title">{{ "vouchers.wallet" | translate }}</p>
    </ion-col>
    <ion-col size="2">
      <ion-icon name="close-circle" class="close-icon" (click)="goBack()"></ion-icon>
    </ion-col>
  </ion-row>
  <div class="voucher-wrapper">
    <ion-grid class="ion-no-padding">
      <!------ enter voucher code block ------>
      <mat-accordion class="accordion-wrapper">
        <mat-expansion-panel [expanded]="vc">
          <mat-expansion-panel-header class="accordion-header">
            <mat-panel-title>
              <ion-row>
                <h2 class="voucher-code-hint">{{ "vouchers.voucher code" | translate }}</h2>
              </ion-row>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ion-row>
            <ion-input [ngClass]="isVoucherIsInvalid$.getValue() ? 'invalid-field' : ''"
              class="input-box-type-1 voucher-code-field" placeholder="{{ 'vouchers.code' | translate }}" #voucherCode
              (input)="getButtonStatus($event.target?.value)" [value]="vc">
            </ion-input>
          </ion-row>
          <ion-row class="voucher-error" *ngIf="isVoucherIsInvalid$.getValue()">
            <p><i class="fas fa-exclamation-triangle"></i> {{ isVoucherIsInvalid$.getValue() }}</p>
          </ion-row>
          <ion-row>
            <ion-button expand="block" color="secondary" class="capsule-btn common-margin claim-now-btn" type="submit"
              [disabled]="!voucherCode?.value || voucherRedemptionService.isVoucherDisableSignal()" (click)="redeemVoucher(voucherCode?.value, false, null); startSpinner()">
              @if((!spinnerAnimation && proceed) || claimFromList) {
              <span>{{ "vouchers.Claim_now" | translate
                }}</span>
              }
              @if(!claimFromList){
              <ng-container>
                <div *ngIf="spinnerAnimation" class="spinners">
                  <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40">
                  </mat-progress-spinner>
                  <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
                  </mat-progress-spinner>
                </div>
                <mat-icon *ngIf="claimSuccess" [@bounceIn] class="tick-mark">done</mat-icon>
              </ng-container>
            }
            </ion-button>
          </ion-row>
        </mat-expansion-panel>
      </mat-accordion>
    </ion-grid>
  </div>



  <ion-grid class="ion-no-padding">
    <ng-container *ngIf="showPartnerOffers; else vouchers">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
        <mat-tab label="My Vouchers">
          <ng-container *ngTemplateOutlet="vouchers"></ng-container>
        </mat-tab>
        <mat-tab label="Partner Offers">
          <iframe class="iframe-Template" [src]="this.partnerOfferIframeLink"></iframe>
        </mat-tab>
      </mat-tab-group>
    </ng-container>
  </ion-grid>
</ion-content>

<ng-template #vouchers>
  <div class="voucher-wallet tabs-wrapper">

    <div class="voucher-wallet">
      <ion-row class="ion-no-padding">
        <h1 class="block-heading">
          {{ "vouchers.Clai" | translate }}
          <span class="awarded-text">{{ "vouchers.awarded_vouchers" | translate }}</span>
        </h1>
      </ion-row>
      <ion-row class="ion-no-padding">
        <p class="claim-with">{{ "vouchers.claim_with" | translate }}</p>
      </ion-row>

      <ng-template #vouchersLoading>
        <div class="spinner-space">
          <ion-spinner name="lines"></ion-spinner>
          <h1 class="getting-list">{{ "vouchers.voucher" | translate }}</h1>
        </div>
      </ng-template>
    </div>

    <div *ngIf="awardedVoucherList$ | async as vouchers; else vouchersLoading" class="voucherListWrapper">
      <div *ngIf="vouchers?.length">
        <div>
          <div *ngFor="let voucher of vouchers; let i = index">
            <ion-item class="your-voucher-item purple-background row-margin">
              <ion-row class="your-voucher-row">
                <ion-col size="8" class="your-voucher-lines-col">

                  <p class="your-voucher-expires font-color-white">
                    <span *ngIf="voucher?.validTime == 0">
                      <div class="expires-text">
                        <span *ngIf="voucher?.remainingTime != 0">
                          {{ "vouchers.Expire" | translate }}
                        </span>
                        <span *ngIf="voucher?.remainingTime == 0" class="expiredVoucher">{{ "vouchers.Expired" |
                          translate
                          }}
                        </span>
                        <div class="expires-time" *ngIf="voucher?.remainingTime != 0">
                          <span class="time-badge">
                            <app-count-down-timer class="remaining-time"
                              (remainingVoucherTime)="getRemainingTime($event, voucher, 0)" type="seconds"
                              [end]="voucher?.expiry_date?.seconds">
                            </app-count-down-timer>
                          </span>🔥
                        </div>
                      </div>
                    </span>
                    <span *ngIf="voucher?.validTime != 0">
                      {{ "vouchers.Valid" | translate }}
                      <span class="expires-time">
                        <app-count-down-timer class="remaining-time"
                          (remainingVoucherTime)="getRemainingTime($event, voucher, 1)" type="seconds" id="validTime"
                          end="{{ voucher?.start_date?.seconds }}"></app-count-down-timer>⏳
                      </span>
                    </span>
                  </p>
                  <p class="your-voucher-lines font-color-white">
                    {{
                    voucher?._voucher_name && voucher?._voucher_name[selectedLanguage]
                    ? voucher?._voucher_name[selectedLanguage]
                    : voucher?.voucher_name
                    }}
                  </p>
                </ion-col>
                <ion-col size="4" class="claim-col">
                  <ng-lottie *ngIf="i === 0 && checklistVoucherStatus == false" class="click-animation"
                    [options]="{ path : '../../../assets/tap-animation.json' }"></ng-lottie>
                  <p class="claim">
                    <ng-container
                      *ngIf="(voucher && !voucher?.isClaiming) || !claimFromList || (!spinnerAnimation && proceed)">
                      @if(voucher?.validTime == 0){
                      <button class="claimBtn"
                        (click)="redeemVoucher(voucher?.voucher_code, true, voucher); startSpinner()"
                         [disabled]="voucher?.remainingTime == 0 || voucherRedemptionService.isVoucherDisableSignal()">
                        {{ voucher?.discount_voucher ? voucher?.button_label : ("vouchers.Clai" | translate) }}
                      </button>
                    }
                    @if(voucher?.validTime != 0){
                      <button class="awaitingBtn" [disabled]="true">
                        {{ "vouchers.Awaiting" | translate }}
                      </button>
                    }
                    </ng-container>

                    <ng-container *ngIf="voucher && voucher?.isClaiming && claimFromList">
                      <span *ngIf="spinnerAnimation" class="spinners">
                        <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="30">
                        </mat-progress-spinner>
                        <mat-progress-spinner class="claimlist-spinner" mode="determinate" [value]="progressBar"
                          diameter="30">
                        </mat-progress-spinner>
                      </span>
                      <mat-icon *ngIf="claimSuccess" [@bounceIn] class="tick-mark">done</mat-icon>
                    </ng-container>
                  </p>
                </ion-col>
              </ion-row>
            </ion-item>
          </div>
        </div>
      </div>
      <ion-row class="" *ngIf="!vouchers?.length">
        <ion-col size="8" class="info-text">
          <p>{{ "vouchers.account" | translate }}</p>
          <button (click)="navigateToStore()" class="explore-offer">{{ "vouchers.Explore" | translate }}</button>
        </ion-col>
        <ion-col size="4" class="info-img">
          <img src="../../../assets/images/Vouchers.png" alt="Vouchers img" />
        </ion-col>

        <div class="card-container">
          <div class="card-details">
            <div class="card-title">
              <p>{{ "vouchers.banner_first_line" | translate}}</p>
              <p>{{ "vouchers.banner_second_line" | translate }}</p>
            </div>
            <p class="card-description">{{ "vouchers.banner_description" | translate }}</p>
            <button class="card-button" (click)="clickOfferBanner()">{{ "game_details_page.play_now" | translate
              }}</button>
          </div>
          <div class="card-image-container">
            <img src="../../../assets/images/voucher-image.svg" alt="voucher-euro-img">
          </div>
        </div>
      </ion-row>
      @if (isPushNotification()) {
    <app-push-notification-banner [notificationData]="inlineNotificationDetails"></app-push-notification-banner>
    } @else if (isAddHomeScreen()) {
    <app-add-home-screen-banner [notificationData]="inlineNotificationDetails"></app-add-home-screen-banner>
    } @else {
    @if (inlineNotificationDetails && inlineNotificationDetails?.content) {
     <div
          class="push-notification"
          [ngClass]="{ 'main-head-notification': inlineNotificationDetails?.style === 'promotional' }"
          [style.background]="inlineNotificationDetails?.style === 'promotional' ? inlineNotificationDetails?.background : null"
        >
          <div class="notification-header">
            <div class="header">
              <div class="bell-wrapper">
                <img
                  [src]="getIconUrl(inlineNotificationDetails?.icon_url)"
                  alt="Bell icon"
                  loading="lazy"
                  width="25"
                />
              </div>
              <p [innerHTML]="inlineNotificationDetails?.content?.title"></p>
            </div>
            <img
              [src]="'assets/icon/' + (inlineNotificationDetails?.style === 'promotional' ? 'close-circle.svg' : 'close-gray.webp')"
              alt="Close Notification"
              class="close-notify"
              loading="lazy"
              (click)="feedBackDismiss()"
            />
          </div>
          <div class="notify-content">
            <div>
              <p
                class="content-title title-description"
                [innerHTML]="inlineNotificationDetails?.content?.line_1"
              ></p>
              <p class="content-subtitle" [innerHTML]="inlineNotificationDetails?.content?.line_2"></p>
            </div>
            <button 
            class="active-btn" 
            [ngClass]="{ 'with-countdown': countdownSeconds }"
            [disabled]="isVoucherClaimedSignal()"
            (click)="handleInlineNotification(inlineNotificationDetails)">

            {{ inlineNotificationDetails?.content?.button_label }}
            @if(countdownSeconds){
            <span class="timer-text">{{ voucherNotificationService.claimTimerDisplay }}</span>
            }
            </button>
            @if(countdownSeconds){
            <countdown-timer [seconds]="countdownSeconds" (formattedTime)="voucherNotificationService.claimTimerDisplay = $event"
              (countdownFinished)="handleCountdownFinish()">
            </countdown-timer>
          }
          </div>
        </div>
    }
    }
      <!-- Upcoming Vouchers -->
      <ion-grid class="ion-no-padding" *ngIf="voucherList$ | async as vouchers; else vouchersLoading">
        <div *ngIf="vouchers.length > 0">
          <div class="voucher-wallet">
            <ion-row class="ion-no-padding">
              <h1 class="block-heading">{{ "vouchers.upcoming Claim" | translate }}</h1>
            </ion-row>
            <ion-row class="ion-no-padding">
              <p class="claim-with">{{ "vouchers.good_things" | translate }}</p>
            </ion-row>
            <ng-template #vouchersLoading>
              <div class="spinner-space">
                <ion-spinner name="lines"></ion-spinner>
                <h1 class="getting-list">{{ "vouchers.Future" | translate }}</h1>
              </div>
            </ng-template>
          </div>
          <div class="voucherListWrapper" style="margin-top: 5px;">
            <div *ngIf="vouchers?.length">
              <!-- add "fade" class for disbled cards -->

              <swiper [config]="storeSliderOptions">
                <ng-template swiperSlide *ngFor="let voucher of vouchers; trackBy: trackVoucher">
                  <ion-item class="your-voucher-item item-margin">
                    <ion-row class="your-voucher-row min-height">
                      <ion-col size="8" class="your-voucher-lines-col">
                        <p class="your-voucher-lines font-color-black">
                          {{
                          voucher?._voucher_name && voucher?._voucher_name[selectedLanguage]
                          ? voucher?._voucher_name[selectedLanguage]
                          : voucher?.voucher_name
                          }}
                        </p>
                        <p class="your-voucher-expires font-color-lightgrey">
                          <span *ngIf="voucher?.validTime == 0">
                            <span *ngIf="voucher?.remainingTime != 0">
                              {{ "vouchers.Expire" | translate }}
                            </span>
                            <span *ngIf="voucher?.remainingTime == 0" class="expiredVoucher">
                              {{ "vouchers.Expired" | translate }}
                            </span>
                            <span class="expires-time font-color-skyblue" *ngIf="voucher?.remainingTime != 0">
                              <app-count-down-timer class="remaining-time font-color-skyblue"
                                (remainingVoucherTime)="getRemainingTime($event, voucher, 0)" type="seconds"
                                end="{{ voucher?.expiry_date?.seconds }}"></app-count-down-timer>⏳
                            </span>
                          </span>
                          <span *ngIf="voucher?.validTime != 0">
                            {{ "vouchers.Valid" | translate }}
                            <span class="expires-time">
                              <app-count-down-timer class="remaining-time font-color-skyblue"
                                (remainingVoucherTime)="getRemainingTime($event, voucher, 1)" type="seconds"
                                id="validTime" end="{{ voucher?.start_date?.seconds }}"></app-count-down-timer>⏳
                            </span>
                          </span>
                        </p>
                      </ion-col>
                      <ion-col size="4" class="claim-col">
                        <p class="claim light_purple">
                          <ng-container
                            *ngIf="!voucher?.isClaiming || !claimFromList || (!spinnerAnimation && proceed)">
                            @if(voucher?.validTime == 0){
                            <button class="claimBtn"
                              (click)="redeemVoucher(voucher?.voucher_code, true, voucher); startSpinner()"
                               [disabled]="voucher?.remainingTime == 0 || !isOnline || voucherRedemptionService.isVoucherDisableSignal()">
                              {{ "vouchers.Clai" | translate }}
                            </button>
                          }
                          @if(voucher?.validTime != 0){
                            <button class="awaitingBtn" [disabled]="true">
                              {{ "vouchers.Clai" | translate }}
                            </button>
                          }
                          </ng-container>

                          <ng-container *ngIf="voucher?.isClaiming && claimFromList">
                            <span *ngIf="spinnerAnimation" class="spinners">
                              <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="30">
                              </mat-progress-spinner>
                              <mat-progress-spinner class="claimlist-spinner" mode="determinate" [value]="progressBar"
                                diameter="30">
                              </mat-progress-spinner>
                            </span>
                            <mat-icon *ngIf="claimSuccess" [@bounceIn] class="tick-mark">done</mat-icon>
                          </ng-container>
                        </p>
                      </ion-col>
                    </ion-row>
                  </ion-item>
                </ng-template>
                
              </swiper>
            </div>
          </div>
        </div>
      </ion-grid>
    </div>
  </div>
</ng-template>
